import React from 'react';
import classNames from 'classnames';

interface Props {
  id: string;
  options: {
    [key: string]: string;
  };
  value: string;
  label?: string;
  fieldClass: string;
  labelClass?: string;
  className?: string;
  selectClass?: string;
  isLabelHidden: boolean;
  disableMobileNative: boolean;
  handleChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Select: React.StatelessComponent<Props> = ({
  id,
  options,
  value,
  label,
  handleChange,
  fieldClass,
  labelClass,
  selectClass,
  isLabelHidden,
  disableMobileNative,
}) => {
  const fieldClassName = classNames(
    'dna-form-field',
    disableMobileNative ? 'disable-mobile-native' : null,
    fieldClass
  );
  const labelClassName = classNames('dna-label', labelClass, {
    'dna-invisible': isLabelHidden,
  });
  const selectClassName = classNames('js-dna-select', selectClass);

  const optionElements = Object.keys(options).map((key, index) => (
    <option value={key} key={index}>
      {options[key]}
    </option>
  ));

  // hack: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/17946
  const selectProps: any = { value };

  return (
    <div className={fieldClassName}>
      <label className={labelClassName} htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className={selectClassName}
        {...selectProps}
        onChange={handleChange}
      >
        {optionElements}
      </select>
    </div>
  );
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/dna/Select.tsx